interface Page<TItem> {
  data: TItem[];
  meta?: { last_page?: number };
}

/**
 * Every page of a paginated index, concatenated in order: page 1 first, to learn
 * `meta.last_page`, then the rest together. The response keeps page 1's
 * envelope with the whole list as its `data`.
 */
export const fetchAllPages = async <TItem, TPage extends Page<TItem>>(
  fetchPage: (page: number) => Promise<TPage>,
): Promise<TPage> => {
  const first = await fetchPage(1);
  const lastPage = first.meta?.last_page ?? 1;
  const rest = await Promise.all(
    Array.from({ length: Math.max(lastPage - 1, 0) }, (_, index) => fetchPage(index + 2)),
  );

  return { ...first, data: [first, ...rest].flatMap((page) => page.data) };
};
